import { useFilter } from "../../../fetch/fetch.filter.ts";
import { EMPTY_FILTER } from "../../../const/typeDefault/Filter.ts";
import { FilterType } from "../../../types/Filter";

const FilterFetch = ({
  filterId,
  children,
  fallback,
}: {
  filterId: string;
  children: (filter: FilterType) => React.ReactNode;
  fallback: React.ReactNode;
}) => {
  const { filter, isLoading, isError } = useFilter(filterId, EMPTY_FILTER);
  if (isLoading) return fallback;
  if (isError) return isError.message;
  return children(filter);
};
export default FilterFetch;
